// extracted by mini-css-extract-plugin
export default {"container":"PeriodSelection_container__w5dho","label":"PeriodSelection_label__D-4wo","blue":"PeriodSelection_blue__YwAxy"};